import ReadyInfo from '@src/components/ReadyInfo'
import SelectedRepairShopInfo from '@src/components/SelectedRepairShopInfo'
import SvvSpinner from '@src/components/SvvSpinner'
import useRepairShopMatch from '@src/hooks/useRepairShopMatch'
import { getErrorPath } from '@src/utils/errorPathUtils'
import React, { Fragment, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'

const ReadyPage = () => {
  const { uuid } = useParams()
  const { searchResult, loading } = useRepairShopMatch(uuid)
  const navigate = useNavigate()
  const { t } = useTranslation('repairshop')

  const selectedRepairShop = searchResult
    ? searchResult.results.find((repairShop) => repairShop.selected)
    : null

  useEffect(() => {
    if (searchResult && (!uuid || !selectedRepairShop)) {
      navigate(getErrorPath(uuid))
    }
  }, [navigate, selectedRepairShop, searchResult, uuid])

  if (loading) {
    return <SvvSpinner />
  }

  return (
    <Fragment>
      <ReadyInfo
        imageBaseName="ready"
        title={t('ready-page.title')}
        text={t('ready-page.info')}
      />
      <SelectedRepairShopInfo repairShop={selectedRepairShop} />
    </Fragment>
  )
}

export default ReadyPage
